import { ROUTES_V2_PATHS } from '../../../constants/route-constants';

export const ovoCallbackMessageType = '__ovo_callback__';

export const ovoMFAIFrameID = '__ovo_mfa__';

export const ovoAuthCallbackURL = `${location.protocol}//${
  location.hostname
}/book${ROUTES_V2_PATHS.ovoCallback}`;
